/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ExecRiskApiAppApiV1EagerTasksForm990ModelsCommonTypesBusinessName } from './ExecRiskApiAppApiV1EagerTasksForm990ModelsCommonTypesBusinessName';
import {
    ExecRiskApiAppApiV1EagerTasksForm990ModelsCommonTypesBusinessNameFromJSON,
    ExecRiskApiAppApiV1EagerTasksForm990ModelsCommonTypesBusinessNameFromJSONTyped,
    ExecRiskApiAppApiV1EagerTasksForm990ModelsCommonTypesBusinessNameToJSON,
} from './ExecRiskApiAppApiV1EagerTasksForm990ModelsCommonTypesBusinessName';

/**
 * 
 * @export
 * @interface ExecRiskAgriculturalNameAndAddress
 */
export interface ExecRiskAgriculturalNameAndAddress {
    /**
     * 
     * @type {ExecRiskApiAppApiV1EagerTasksForm990ModelsCommonTypesBusinessName}
     * @memberof ExecRiskAgriculturalNameAndAddress
     */
    CollegeUniversityName?: ExecRiskApiAppApiV1EagerTasksForm990ModelsCommonTypesBusinessName;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskAgriculturalNameAndAddress
     */
    CityNm?: string;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskAgriculturalNameAndAddress
     */
    StateAbbreviationCd?: string;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskAgriculturalNameAndAddress
     */
    CountryCd?: string;
}

/**
 * Check if a given object implements the ExecRiskAgriculturalNameAndAddress interface.
 */
export function instanceOfExecRiskAgriculturalNameAndAddress(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ExecRiskAgriculturalNameAndAddressFromJSON(json: any): ExecRiskAgriculturalNameAndAddress {
    return ExecRiskAgriculturalNameAndAddressFromJSONTyped(json, false);
}

export function ExecRiskAgriculturalNameAndAddressFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExecRiskAgriculturalNameAndAddress {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'CollegeUniversityName': !exists(json, 'CollegeUniversityName') ? undefined : ExecRiskApiAppApiV1EagerTasksForm990ModelsCommonTypesBusinessNameFromJSON(json['CollegeUniversityName']),
        'CityNm': !exists(json, 'CityNm') ? undefined : json['CityNm'],
        'StateAbbreviationCd': !exists(json, 'StateAbbreviationCd') ? undefined : json['StateAbbreviationCd'],
        'CountryCd': !exists(json, 'CountryCd') ? undefined : json['CountryCd'],
    };
}

export function ExecRiskAgriculturalNameAndAddressToJSON(value?: ExecRiskAgriculturalNameAndAddress | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'CollegeUniversityName': ExecRiskApiAppApiV1EagerTasksForm990ModelsCommonTypesBusinessNameToJSON(value.CollegeUniversityName),
        'CityNm': value.CityNm,
        'StateAbbreviationCd': value.StateAbbreviationCd,
        'CountryCd': value.CountryCd,
    };
}

